import { render, staticRenderFns } from "./MainForm.vue?vue&type=template&id=10183a8c&"
import script from "./MainForm.vue?vue&type=script&lang=js&"
export * from "./MainForm.vue?vue&type=script&lang=js&"
import style0 from "./stylesheets/style.scss?vue&type=style&index=0&prod&lang=scss&module=true&"
import style1 from "./stylesheets/section.scss?vue&type=style&index=1&prod&lang=scss&module=%24section&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)
this["$section"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports